import Cookies from "js-cookie";

const hashCode = (str?: string) => {
  let hash = 0;
  if (!str) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

function initNoticeBar() {
  const notice = document.querySelector("#notice-bar") as HTMLElement;
  if (!notice) return;

  const close = notice.querySelector("#notice-dismiss") as HTMLButtonElement;
  const cookieName = "BC211-notice-" + hashCode(notice.dataset.text);
  if (!Cookies.get(cookieName)) {
    notice.classList.remove("hidden");
    close.addEventListener("click", () => {
      notice.classList.add("hidden");
      Cookies.set(cookieName, "true", { expires: 14 });
    });
  } else {
    notice.classList.add("hidden");
  }
}

initNoticeBar();
